import { publicEnv } from '@/lib/env';

const NOT_FOUND_IMG = 'https://cdn.pickleball.com/global/PKL-not-found.svg';
const IS_PRODUCTION = publicEnv.NEXT_PUBLIC_APP_ENV === 'prod';
const IS_DEVELOPMENT = publicEnv.NEXT_PUBLIC_APP_ENV === 'dev';
const IS_TEST = publicEnv.NEXT_PUBLIC_APP_ENV === 'test';

export { NOT_FOUND_IMG, IS_PRODUCTION, IS_DEVELOPMENT, IS_TEST };
